export { onRenderClient }

import React from 'react'
import { hydrateRoot } from 'react-dom/client'

async function onRenderClient(pageContext) {
  const { Page } = pageContext
  hydrateRoot(document.getElementById('root'), <Page />)
}
